import React, { Component } from 'react';

import { translate } from 'react-i18next';

@translate(['common'])

export default class NotFound extends Component {
  render() {
    const {t} = this.props;

    return (
      <div className="container">
        <h1>{t("main.not_found")}</h1>
      </div>
    );
  }
}
